export default {
  sumOfTickets: state => state.sumOfTickets
}
